import React from 'react'

const Brands = () => {
  return (
    <div className='flex justify-center lg:text-xl text-sm font-light pt-12 mt-20 uppercase font-roboto bg-[#fffdf3]'>Brands we've done great work with</div>
  )
}

export default Brands;